/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */

type ErrorWithCode = Error & { code: number };
type MaybeErrorWithCode = ErrorWithCode | null | undefined;

const createErrorFromCodeLookup: Map<number, () => ErrorWithCode> = new Map();
const createErrorFromNameLookup: Map<string, () => ErrorWithCode> = new Map();

/**
 * Unauthorized: 'Unauthorized'
 *
 * @category Errors
 * @category generated
 */
export class UnauthorizedError extends Error {
  readonly code: number = 0x0;
  readonly name: string = "Unauthorized";
  constructor() {
    super("Unauthorized");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, UnauthorizedError);
    }
  }
}

createErrorFromCodeLookup.set(0x0, () => new UnauthorizedError());
createErrorFromNameLookup.set("Unauthorized", () => new UnauthorizedError());

/**
 * NotOnWhitelist: 'NotOnWhitelist'
 *
 * @category Errors
 * @category generated
 */
export class NotOnWhitelistError extends Error {
  readonly code: number = 0x1;
  readonly name: string = "NotOnWhitelist";
  constructor() {
    super("NotOnWhitelist");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, NotOnWhitelistError);
    }
  }
}

createErrorFromCodeLookup.set(0x1, () => new NotOnWhitelistError());
createErrorFromNameLookup.set("NotOnWhitelist", () => new NotOnWhitelistError());

/**
 * SaleWaitingToStart: 'SaleWaitingToStart'
 *
 * @category Errors
 * @category generated
 */
export class SaleWaitingToStartError extends Error {
  readonly code: number = 0x2;
  readonly name: string = "SaleWaitingToStart";
  constructor() {
    super("SaleWaitingToStart");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, SaleWaitingToStartError);
    }
  }
}

createErrorFromCodeLookup.set(0x2, () => new SaleWaitingToStartError());
createErrorFromNameLookup.set("SaleWaitingToStart", () => new SaleWaitingToStartError());

/**
 * SaleEnded: 'SaleEnded'
 *
 * @category Errors
 * @category generated
 */
export class SaleEndedError extends Error {
  readonly code: number = 0x3;
  readonly name: string = "SaleEnded";
  constructor() {
    super("SaleEnded");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, SaleEndedError);
    }
  }
}

createErrorFromCodeLookup.set(0x3, () => new SaleEndedError());
createErrorFromNameLookup.set("SaleEnded", () => new SaleEndedError());

/**
 * InvalidNativeTokens: 'InvalidNativeTokens'
 *
 * @category Errors
 * @category generated
 */
export class InvalidNativeTokensError extends Error {
  readonly code: number = 0x4;
  readonly name: string = "InvalidNativeTokens";
  constructor() {
    super("InvalidNativeTokens");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, InvalidNativeTokensError);
    }
  }
}

createErrorFromCodeLookup.set(0x4, () => new InvalidNativeTokensError());
createErrorFromNameLookup.set("InvalidNativeTokens", () => new InvalidNativeTokensError());

/**
 * MinTickets: 'MinTickets'
 *
 * @category Errors
 * @category generated
 */
export class MinTicketsError extends Error {
  readonly code: number = 0x5;
  readonly name: string = "MinTickets";
  constructor() {
    super("MinTickets");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, MinTicketsError);
    }
  }
}

createErrorFromCodeLookup.set(0x5, () => new MinTicketsError());
createErrorFromNameLookup.set("MinTickets", () => new MinTicketsError());

/**
 * MaxTickets: 'MaxTickets'
 *
 * @category Errors
 * @category generated
 */
export class MaxTicketsError extends Error {
  readonly code: number = 0x6;
  readonly name: string = "MaxTickets";
  constructor() {
    super("MaxTickets");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, MaxTicketsError);
    }
  }
}

createErrorFromCodeLookup.set(0x6, () => new MaxTicketsError());
createErrorFromNameLookup.set("MaxTickets", () => new MaxTicketsError());

/**
 * HandleNotFound: 'HandleNotFound'
 *
 * @category Errors
 * @category generated
 */
export class HandleNotFoundError extends Error {
  readonly code: number = 0x7;
  readonly name: string = "HandleNotFound";
  constructor() {
    super("HandleNotFound");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, HandleNotFoundError);
    }
  }
}

createErrorFromCodeLookup.set(0x7, () => new HandleNotFoundError());
createErrorFromNameLookup.set("HandleNotFound", () => new HandleNotFoundError());

/**
 * WrongEndpointNativeTokens: 'WrongEndpointNativeTokens'
 *
 * @category Errors
 * @category generated
 */
export class WrongEndpointNativeTokensError extends Error {
  readonly code: number = 0x8;
  readonly name: string = "WrongEndpointNativeTokens";
  constructor() {
    super("WrongEndpointNativeTokens");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, WrongEndpointNativeTokensError);
    }
  }
}

createErrorFromCodeLookup.set(0x8, () => new WrongEndpointNativeTokensError());
createErrorFromNameLookup.set("WrongEndpointNativeTokens", () => new WrongEndpointNativeTokensError());

/**
 * ZeroTokensReceived: 'ZeroTokensReceived'
 *
 * @category Errors
 * @category generated
 */
export class ZeroTokensReceivedError extends Error {
  readonly code: number = 0x9;
  readonly name: string = "ZeroTokensReceived";
  constructor() {
    super("ZeroTokensReceived");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, ZeroTokensReceivedError);
    }
  }
}

createErrorFromCodeLookup.set(0x9, () => new ZeroTokensReceivedError());
createErrorFromNameLookup.set("ZeroTokensReceived", () => new ZeroTokensReceivedError());

/**
 * InvalidAssetProvided: 'InvalidAssetProvided'
 *
 * @category Errors
 * @category generated
 */
export class InvalidAssetProvidedError extends Error {
  readonly code: number = 0xa;
  readonly name: string = "InvalidAssetProvided";
  constructor() {
    super("InvalidAssetProvided");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, InvalidAssetProvidedError);
    }
  }
}

createErrorFromCodeLookup.set(0xa, () => new InvalidAssetProvidedError());
createErrorFromNameLookup.set("InvalidAssetProvided", () => new InvalidAssetProvidedError());

/**
 * TargetAssetNotConfigured: 'TargetAssetNotConfigured'
 *
 * @category Errors
 * @category generated
 */
export class TargetAssetNotConfiguredError extends Error {
  readonly code: number = 0xb;
  readonly name: string = "TargetAssetNotConfigured";
  constructor() {
    super("TargetAssetNotConfigured");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, TargetAssetNotConfiguredError);
    }
  }
}

createErrorFromCodeLookup.set(0xb, () => new TargetAssetNotConfiguredError());
createErrorFromNameLookup.set("TargetAssetNotConfigured", () => new TargetAssetNotConfiguredError());

/**
 * WalletTicketCap: 'WalletTicketCap'
 *
 * @category Errors
 * @category generated
 */
export class WalletTicketCapError extends Error {
  readonly code: number = 0xc;
  readonly name: string = "WalletTicketCap";
  constructor() {
    super("WalletTicketCap");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, WalletTicketCapError);
    }
  }
}

createErrorFromCodeLookup.set(0xc, () => new WalletTicketCapError());
createErrorFromNameLookup.set("WalletTicketCap", () => new WalletTicketCapError());

/**
 * CollectBidAssetsOnlyAvailableAfterSaleProcessEnds: 'CollectBidAssetsOnlyAvailableAfterSaleProcessEnds'
 *
 * @category Errors
 * @category generated
 */
export class CollectBidAssetsOnlyAvailableAfterSaleProcessEndsError extends Error {
  readonly code: number = 0xd;
  readonly name: string = "CollectBidAssetsOnlyAvailableAfterSaleProcessEnds";
  constructor() {
    super("CollectBidAssetsOnlyAvailableAfterSaleProcessEnds");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, CollectBidAssetsOnlyAvailableAfterSaleProcessEndsError);
    }
  }
}

createErrorFromCodeLookup.set(0xd, () => new CollectBidAssetsOnlyAvailableAfterSaleProcessEndsError());
createErrorFromNameLookup.set(
  "CollectBidAssetsOnlyAvailableAfterSaleProcessEnds",
  () => new CollectBidAssetsOnlyAvailableAfterSaleProcessEndsError()
);

/**
 * SaleProcessAlreadyEnded: 'SaleProcessAlreadyEnded'
 *
 * @category Errors
 * @category generated
 */
export class SaleProcessAlreadyEndedError extends Error {
  readonly code: number = 0xe;
  readonly name: string = "SaleProcessAlreadyEnded";
  constructor() {
    super("SaleProcessAlreadyEnded");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, SaleProcessAlreadyEndedError);
    }
  }
}

createErrorFromCodeLookup.set(0xe, () => new SaleProcessAlreadyEndedError());
createErrorFromNameLookup.set("SaleProcessAlreadyEnded", () => new SaleProcessAlreadyEndedError());

/**
 * SaleCancelled: 'SaleCancelled'
 *
 * @category Errors
 * @category generated
 */
export class SaleCancelledError extends Error {
  readonly code: number = 0xf;
  readonly name: string = "SaleCancelled";
  constructor() {
    super("SaleCancelled");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, SaleCancelledError);
    }
  }
}

createErrorFromCodeLookup.set(0xf, () => new SaleCancelledError());
createErrorFromNameLookup.set("SaleCancelled", () => new SaleCancelledError());

/**
 * SaleAlreadyEnded: 'SaleAlreadyEnded'
 *
 * @category Errors
 * @category generated
 */
export class SaleAlreadyEndedError extends Error {
  readonly code: number = 0x10;
  readonly name: string = "SaleAlreadyEnded";
  constructor() {
    super("SaleAlreadyEnded");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, SaleAlreadyEndedError);
    }
  }
}

createErrorFromCodeLookup.set(0x10, () => new SaleAlreadyEndedError());
createErrorFromNameLookup.set("SaleAlreadyEnded", () => new SaleAlreadyEndedError());

/**
 * SaleNotCancelled: 'SaleNotCancelled'
 *
 * @category Errors
 * @category generated
 */
export class SaleNotCancelledError extends Error {
  readonly code: number = 0x11;
  readonly name: string = "SaleNotCancelled";
  constructor() {
    super("SaleNotCancelled");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, SaleNotCancelledError);
    }
  }
}

createErrorFromCodeLookup.set(0x11, () => new SaleNotCancelledError());
createErrorFromNameLookup.set("SaleNotCancelled", () => new SaleNotCancelledError());

/**
 * ContractStopped: 'ContractStopped'
 *
 * @category Errors
 * @category generated
 */
export class ContractStoppedError extends Error {
  readonly code: number = 0x12;
  readonly name: string = "ContractStopped";
  constructor() {
    super("ContractStopped");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, ContractStoppedError);
    }
  }
}

createErrorFromCodeLookup.set(0x12, () => new ContractStoppedError());
createErrorFromNameLookup.set("ContractStopped", () => new ContractStoppedError());

/**
 * SaleNotRunning: 'SaleNotRunning'
 *
 * @category Errors
 * @category generated
 */
export class SaleNotRunningError extends Error {
  readonly code: number = 0x13;
  readonly name: string = "SaleNotRunning";
  constructor() {
    super("SaleNotRunning");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, SaleNotRunningError);
    }
  }
}

createErrorFromCodeLookup.set(0x13, () => new SaleNotRunningError());
createErrorFromNameLookup.set("SaleNotRunning", () => new SaleNotRunningError());

/**
 * InvalidIncentive: 'InvalidIncentive'
 *
 * @category Errors
 * @category generated
 */
export class InvalidIncentiveError extends Error {
  readonly code: number = 0x14;
  readonly name: string = "InvalidIncentive";
  constructor() {
    super("InvalidIncentive");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, InvalidIncentiveError);
    }
  }
}

createErrorFromCodeLookup.set(0x14, () => new InvalidIncentiveError());
createErrorFromNameLookup.set("InvalidIncentive", () => new InvalidIncentiveError());

/**
 * InvalidIncentiveReward: 'InvalidIncentiveReward'
 *
 * @category Errors
 * @category generated
 */
export class InvalidIncentiveRewardError extends Error {
  readonly code: number = 0x15;
  readonly name: string = "InvalidIncentiveReward";
  constructor() {
    super("InvalidIncentiveReward");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, InvalidIncentiveRewardError);
    }
  }
}

createErrorFromCodeLookup.set(0x15, () => new InvalidIncentiveRewardError());
createErrorFromNameLookup.set("InvalidIncentiveReward", () => new InvalidIncentiveRewardError());

/**
 * InvalidRewardAmount: 'InvalidIncentiveAmount'
 *
 * @category Errors
 * @category generated
 */
export class InvalidRewardAmountError extends Error {
  readonly code: number = 0x16;
  readonly name: string = "InvalidRewardAmount";
  constructor() {
    super("InvalidIncentiveAmount");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, InvalidRewardAmountError);
    }
  }
}

createErrorFromCodeLookup.set(0x16, () => new InvalidRewardAmountError());
createErrorFromNameLookup.set("InvalidRewardAmount", () => new InvalidRewardAmountError());

/**
 * NotWritable: 'NotWritable'
 *
 * @category Errors
 * @category generated
 */
export class NotWritableError extends Error {
  readonly code: number = 0x17;
  readonly name: string = "NotWritable";
  constructor() {
    super("NotWritable");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, NotWritableError);
    }
  }
}

createErrorFromCodeLookup.set(0x17, () => new NotWritableError());
createErrorFromNameLookup.set("NotWritable", () => new NotWritableError());

/**
 * NotSigner: 'NotSigner'
 *
 * @category Errors
 * @category generated
 */
export class NotSignerError extends Error {
  readonly code: number = 0x18;
  readonly name: string = "NotSigner";
  constructor() {
    super("NotSigner");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, NotSignerError);
    }
  }
}

createErrorFromCodeLookup.set(0x18, () => new NotSignerError());
createErrorFromNameLookup.set("NotSigner", () => new NotSignerError());

/**
 * InvalidBid: 'InvalidBid'
 *
 * @category Errors
 * @category generated
 */
export class InvalidBidError extends Error {
  readonly code: number = 0x19;
  readonly name: string = "InvalidBid";
  constructor() {
    super("InvalidBid");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, InvalidBidError);
    }
  }
}

createErrorFromCodeLookup.set(0x19, () => new InvalidBidError());
createErrorFromNameLookup.set("InvalidBid", () => new InvalidBidError());

/**
 * IllegalOwner: 'IllegalOwner'
 *
 * @category Errors
 * @category generated
 */
export class IllegalOwnerError extends Error {
  readonly code: number = 0x1a;
  readonly name: string = "IllegalOwner";
  constructor() {
    super("IllegalOwner");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, IllegalOwnerError);
    }
  }
}

createErrorFromCodeLookup.set(0x1a, () => new IllegalOwnerError());
createErrorFromNameLookup.set("IllegalOwner", () => new IllegalOwnerError());

/**
 * SaleNotEnded: 'SaleNotEnded'
 *
 * @category Errors
 * @category generated
 */
export class SaleNotEndedError extends Error {
  readonly code: number = 0x1b;
  readonly name: string = "SaleNotEnded";
  constructor() {
    super("SaleNotEnded");
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, SaleNotEndedError);
    }
  }
}

createErrorFromCodeLookup.set(0x1b, () => new SaleNotEndedError());
createErrorFromNameLookup.set("SaleNotEnded", () => new SaleNotEndedError());

/**
 * Attempts to resolve a custom program error from the provided error code.
 * @category Errors
 * @category generated
 */
export function errorFromCode(code: number): MaybeErrorWithCode {
  const createError = createErrorFromCodeLookup.get(code);
  return createError != null ? createError() : null;
}

/**
 * Attempts to resolve a custom program error from the provided error name, i.e. 'Unauthorized'.
 * @category Errors
 * @category generated
 */
export function errorFromName(name: string): MaybeErrorWithCode {
  const createError = createErrorFromNameLookup.get(name);
  return createError != null ? createError() : null;
}
